// import React, { useEffect, useState, useRef } from "react";
// import {
//   bp_inventory_data,
//   bp_material_inentory_data,
//   bp_units_data,
//   bp_location_data,
//   bp_supplier_data,
//   bp_material_data,
//   bp_material_type_data,
//   update_material_inventory,
// } from "../../../utils/api";
// import { toast } from "react-toastify";
// import { Table, Pagination } from "antd";
// import { PlusOutlined } from '@ant-design/icons';
// import { CloseOutlined } from '@ant-design/icons';

// Ant Design components are used instead of MUI
// import { Select } from "antd";
// import ConfigModal from "./ConfigModal";
// import { useDispatch, useSelector } from "react-redux";
// import { set_submit_status } from '@/store/reducers/submit_status';

// function AddIngredient({
//   set_is_model_open,
//   type_id,
//   set_type_id,
//   get_submit_status,
//   set_get_submit_status,
//   isEdit,
//   editRecord,
//   set_isEdit,
// }) {
//   const dispatch = useDispatch();
//   const [get_status, set_get_status] = useState(false);
//   const submit_status = useSelector((state) => state.submit_status);
//   const selectedModule = useSelector((state) => state.moduleView);
//   const formRef = useRef();
//   const [inventoryData, setInventoryData] = useState();
//   const [locationData, setLocationData] = useState();
//   const [materialData, setMaterialData] = useState();
//   const [material_type_data, set_material_type_data] = useState();
//   const [supplierData, setSupplierData] = useState();
//   const [unitData, setUnitsData] = useState();
//   function validateInput(input) {
//     const regex = /^(\d+(\.\d+)?)(,\s*\d+(\.\d+)?)*$/;
//     return regex.test(input);
//   }
//   const [inventoryReq, setInventoryReq] = useState({
//     material_name_id: "",
//     material_type_id: "",
//     unit_id: "",
//     packaging_size: "",
//     // location_id: "i",
//     // supplier_id: "i",
//     // batch_number: "",
//     specifications: "",
//     validity: "",
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setInventoryReq((prevInventoryReq) => ({
//       ...prevInventoryReq,
//       packaging_size: prevInventoryReq?.packaging_size?.replace(/,\s*$/, ""), // Replace `newValue` with the actual value you want to set
//       module_type: selectedModule,
//     }));

//     if (validateInput(inventoryReq?.packaging_size?.replace(/,\s*$/, ""))) {
//       add_Inventory(inventoryReq);
//     } else {
//       toast.warning(
//         "Invalid Packaging Sizes: Sizes should only contain numbers (including decimals) separated by commas"
//       );
//     }
//   };

//   useEffect(() => {
//     setInventoryReq({
//       ...inventoryReq,
//       material_type_id: type_id || "",
//       material_name_id: "",
//       unit_id: "",
//       packaging_size: "",
//       // supplier_id: "i",isEdit
//       // batch_number: "",
//       specifications: "",
//       validity: "",
//     });
//   }, [submit_status, type_id]);

//   useEffect(() => {
//     if (isEdit && editRecord) {
//       console.log(editRecord);

//       setInventoryReq({
//         material_inventory_id: editRecord?.material_inventory_id,
//         material_name_id: editRecord?.material_name_id,
//         material_type_id: editRecord?.material_type_id,
//         unit_id: editRecord?.unit_id,
//         packaging_size: editRecord?.packaging_size,
//         specifications: editRecord?.specification,
//         validity: editRecord?.validity,
//       });
//     }
//   }, [isEdit, editRecord]);

//   //####################### Handle Api's######################################################

//   const get_all_inventory = async () => {
//     try {
//       await bp_inventory_data(
//         { module_type: selectedModule },
//         success_inventory_list_get
//       );
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   const success_inventory_list_get = (res) => {
//     console.log("res", res);
//     setInventoryData(res?.data?.data);
//   };

//   const get_all_dropDown_Data = async () => {
//     try {
//       await bp_location_data(success_location_list_get);
//       await bp_material_data(
//         { module_type: selectedModule },
//         success_material_list_get
//       );
//       await bp_material_type_data(success_material_type_list_get);
//       await bp_supplier_data(success_supplier_list_get);
//       await bp_units_data(success_units_list_get);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const success_location_list_get = (res) => {
//     console.log("res", res);
//     setLocationData(res?.data?.data);
//   };

//   const success_material_list_get = (res) => {
//     console.log("res", res);
//     setMaterialData(res?.data?.data);
//   };
//   const success_material_type_list_get = (res) => {
//     console.log("res", res);
//     set_material_type_data(res?.data?.data);
//   };
//   const success_supplier_list_get = (res) => {
//     console.log("res", res);
//     setSupplierData(res?.data?.data);
//   };
//   const success_units_list_get = (res) => {
//     console.log("res", res);
//     setUnitsData(res?.data?.data);
//   };

//   //Add inventory
//   const add_Inventory = async (inventoryReq) => {
//     try {
//       if (isEdit) {
//         await update_material_inventory(inventoryReq, success_add_inventory);
//       } else {
//         await bp_material_inentory_data(inventoryReq, success_add_inventory);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const success_add_inventory = (res) => {
//     console.log(res);
//     if (res.status === "failed") {
//       toast.warning(res.message);
//     } else {
//       toast.success(res.message);
//       reset_function();
//       get_all_inventory();
//       set_get_submit_status(!get_submit_status);
//       set_type_id(0);
//       dispatch(set_submit_status());
//       set_is_model_open(false);
//       set_isEdit(false);
//     }
//   };

//   const reset_function = () => {
//     setInventoryReq({
//       material_name_id: "",
//       material_type_id: "",
//       packaging_size: "",
//       // quantity: "",
//       unit_id: "",
//       // location_id: "i",
//       // supplier_id: "i",
//       // batch_number: "",
//       specifications: "",
//       validity: "",
//     });
//   };
//   const get_all_dropDown_Data_on_submit = async () => {
//     try {
//       add_number === 3 && (await bp_location_data(success_location_list_get));
//       add_number === 1 &&
//         (await bp_material_data(
//           { module_type: selectedModule },
//           success_material_list_get
//         ));
//       add_number === 2 && (await bp_units_data(success_units_list_get));
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     get_all_dropDown_Data_on_submit();
//   }, [get_status]);

//   useEffect(() => {
//     get_all_inventory();
//     get_all_dropDown_Data();
//   }, [selectedModule]);

//   //   =============================================================
//   const [show_modal, set_show_modal] = useState(false);
//   const [add_number, set_add_number] = useState(0);

//   return (
//     <>
//       <form ref={formRef} onSubmit={handleSubmit}>
//         <Grid container spacing={2} style={{ display: "flex" }}>
//           <Grid item xs={3}>
//             <Stack spacing={1}>
//               <InputLabel htmlFor="title">Material</InputLabel>
//               <Stack direction="row" spacing={1}>
//                 <Select
//                   showSearch
//                   id="demo-select-small"
//                   disabled={isEdit}
//                   value={inventoryReq["material_name_id"] || null}
//                   size="large"
//                   style={{
//                     width: "100%",

//                     borderRadius: "3px",
//                   }}
//                   bordered
//                   placeholder="Select Material"
//                   optionFilterProp="children"
//                   filterOption={(input, option) =>
//                     option.children.toLowerCase().includes(input.toLowerCase())
//                   }
//                   filterSort={(optionA, optionB) =>
//                     optionA.children.localeCompare(optionB.children)
//                   }
//                   dropdownStyle={{
//                     maxHeight: 400,
//                     overflow: "auto",
//                   }}
//                   onChange={(value) =>
//                     setInventoryReq({
//                       ...inventoryReq,
//                       material_name_id: value,
//                     })
//                   }
//                 >
//                   {materialData?.map((mdata) => (
//                     <Select.Option
//                       key={mdata.material_id}
//                       value={mdata.material_id}
//                     >
//                       {mdata.material_name}
//                     </Select.Option>
//                   ))}
//                 </Select>
//                 {!isEdit && (
//                   <Tooltip title="Add Material">
//                     <IconButton
//                       onClick={() => {
//                         set_show_modal(true);
//                         set_add_number(1);
//                       }}
//                     >
//                       <PlusOutlined
//                         style={{
//                           color: "#00C853",
//                           fontSize: "32px",
//                         }}
//                       />
//                     </IconButton>
//                   </Tooltip>
//                 )}
//               </Stack>
//             </Stack>
//           </Grid>

//           <Grid item xs={3}>
//             <Stack spacing={1}>
//               <InputLabel htmlFor="title">Material Type</InputLabel>
//               <Stack direction="row" spacing={1}>
//                 <Select
//                   showSearch
//                   disabled={isEdit}
//                   id="demo-select-small"
//                   value={inventoryReq["material_type_id"] || null}
//                   size="large"
//                   style={{
//                     width: "100%",

//                     borderRadius: "3px",
//                   }}
//                   bordered
//                   placeholder="Select Material Type"
//                   optionFilterProp="children"
//                   filterOption={(input, option) =>
//                     option.children.toLowerCase().includes(input.toLowerCase())
//                   }
//                   filterSort={(optionA, optionB) =>
//                     optionA.children.localeCompare(optionB.children)
//                   }
//                   dropdownStyle={{
//                     maxHeight: 400,
//                     overflow: "auto",
//                   }}
//                   onChange={(value) =>
//                     setInventoryReq({
//                       ...inventoryReq,
//                       material_type_id: value,
//                     })
//                   }
//                 >
//                   {material_type_data?.map((mdata) => (
//                     <Select.Option
//                       key={mdata.material_type_id}
//                       value={mdata.material_type_id}
//                     >
//                       {mdata.material_type}
//                     </Select.Option>
//                   ))}
//                 </Select>
//               </Stack>
//             </Stack>
//           </Grid>

//           <Grid item xs={3}>
//             <Stack spacing={1}>
//               <InputLabel htmlFor="size">Standard Packaging Size</InputLabel>
//               <OutlinedInput
//                 id="title"
//                 size="medium"
//                 type="text"
//                 name="size"
//                 placeholder="Packaging Size"
//                 fullWidth
//                 inputProps={{ min: 0 }}
//                 value={inventoryReq?.packaging_size}
//                 required
//                 onChange={(e) =>
//                   setInventoryReq({
//                     ...inventoryReq,
//                     packaging_size: e?.target?.value,
//                   })
//                 }
//               />
//             </Stack>
//             <FormHelperText style={{ fontSize: "13px" }}>
//               Enter Sizes like 2, 3, 4, 5
//             </FormHelperText>
//           </Grid>
//           <Grid item xs={3}>
//             <Stack spacing={1}>
//               <InputLabel htmlFor="title">Unit</InputLabel>
//               <Stack direction="row" spacing={1}>
//                 <Select
//                   showSearch
//                   id="demo-select-small"
//                   value={inventoryReq?.unit_id || null}
//                   size="large"
//                   style={{
//                     width: "100%",

//                     borderRadius: "3px",
//                   }}
//                   bordered
//                   placeholder="Select Unit"
//                   optionFilterProp="children"
//                   filterOption={(input, option) =>
//                     option.children.toLowerCase().includes(input.toLowerCase())
//                   }
//                   filterSort={(optionA, optionB) =>
//                     optionA.children.localeCompare(optionB.children)
//                   }
//                   dropdownStyle={{
//                     maxHeight: 400,
//                     overflow: "auto",
//                   }}
//                   onChange={(value) =>
//                     setInventoryReq({
//                       ...inventoryReq,
//                       unit_id: value,
//                     })
//                   }
//                 >
//                   {unitData?.map((mdata) => (
//                     <Select.Option key={mdata.id} value={mdata.id}>
//                       {mdata.unit_name}
//                     </Select.Option>
//                   ))}
//                 </Select>
//                 <Tooltip title="Add Unit">
//                   <IconButton
//                     onClick={() => {
//                       set_show_modal(true);
//                       set_add_number(2);
//                     }}
//                   >
//                     <PlusOutlined
//                       style={{
//                         color: "#00C853",
//                         fontSize: "32px",
//                       }}
//                     />
//                   </IconButton>
//                 </Tooltip>
//               </Stack>
//             </Stack>
//           </Grid>
//           {isEdit && (
//             <Grid item xs={3}>
//               <Stack spacing={1}>
//                 <InputLabel htmlFor="title">Validity(Days)</InputLabel>
//                 <OutlinedInput
//                   id="title"
//                   size="medium"
//                   type="number"
//                   name="validity"
//                   placeholder="Enter validity"
//                   fullWidth
//                   value={inventoryReq?.validity}
//                   onChange={(e) =>
//                     setInventoryReq({
//                       ...inventoryReq,
//                       validity: e.target.value,
//                     })
//                   }
//                 />
//               </Stack>
//             </Grid>
//           )}
//           <Grid item xs={3}>
//             <Stack spacing={1}>
//               <InputLabel htmlFor="title">Specifications</InputLabel>
//               <OutlinedInput
//                 id="title"
//                 size="medium"
//                 type="text"
//                 name="email"
//                 placeholder="Enter Specifications"
//                 fullWidth
//                 value={inventoryReq.specifications}
//                 onChange={(e) =>
//                   setInventoryReq({
//                     ...inventoryReq,
//                     specifications: e.target.value,
//                   })
//                 }
//               />
//             </Stack>
//           </Grid>

//           <Grid item xs={12}>
//             <Stack
//               direction="row"
//               justifyContent="end"
//               spacing={1}
//               style={{ margin: 8 }}
//             >
//               <Button
//                 size="small"
//                 type="reset"
//                 variant="contained"
//                 color="primary"
//                 className="mx-2 bg-blue-500"
//                 onClick={reset_function}
//               >
//                 Reset
//               </Button>
//               <Button
//                 size="small"
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 className="bg-blue-500"
//                 disabled={
//                   !(
//                     (
//                       inventoryReq["material_name_id"] !== "" &&
//                       //     inventoryReq["quantity"]!== ""&&
//                       inventoryReq["unit_id"] !== "" &&
//                       inventoryReq["material_type_id"] !== ""
//                     )
//                     //    inventoryReq["location_id"]!== "i"&&
//                     // inventoryReq["supplier_id"]!== "i"&&
//                     //   inventoryReq["batch_number"]!== ""&&
//                   )
//                 }
//               >
//                 {isEdit ? "Update" : "Submit"}
//               </Button>
//             </Stack>
//           </Grid>
//         </Grid>
//       </form>
//       <ConfigModal
//         show_modal={show_modal}
//         set_show_modal={set_show_modal}
//         add_number={add_number}
//         set_add_number={set_add_number}
//         get_status={get_status}
//         set_get_status={set_get_status}
//       />
//     </>
//   );
// }

// export default AddIngredient;

import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, DatePicker, Select, Row, Col, Tooltip, Button, Space, Modal, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";

import {
  bp_inventory_data,
  bp_material_inentory_data,
  bp_units_data,
  bp_material_data,
  bp_material_type_data,
  bp_get_sampling_config_details,
  update_material_inventory,
} from "../../../utils/api";
import ConfigModal from "./ConfigModal";
import { useDispatch, useSelector } from "react-redux";
import { set_submit_status } from '@/store/reducers/submit_status';
import useAppSetting, { useMaterialTypeAlias } from '@/hooks/useAppSetting';

const { Option } = Select;

const AddIngredient = ({
  set_is_model_open,
  type_id,
  set_type_id,
  get_submit_status,
  set_get_submit_status,
  isEdit,
  editRecord,
  set_isEdit,
}) => {
  const dispatch = useDispatch();
  const selectedModule = useSelector((state) => state.moduleView);
  const isKittingEnabled = useAppSetting('Kitting Enable');
  const getMaterialTypeAlias = useMaterialTypeAlias();

  // Dropdown data
  const [materialData, setMaterialData] = useState([]);
  const [materialTypeData, setMaterialTypeData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const [parameterData, setParameterData] = useState([]);
  const [testingTypeData, setTestingTypeData] = useState([]);

  // Industry-standard pharma batch number: BN-YYJJJ-NNNN
  // YY = 2-digit year, JJJ = Julian day of year (001-366), NNNN = 4-char alphanumeric sequence
  const generateBatchNumber = () => {
    const now = new Date();
    const yy = String(now.getFullYear()).slice(-2);
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = now - start;
    const jjj = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(3, "0");
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // omit I,O,1,0
    let seq = "";
    for (let i = 0; i < 4; i++) seq += chars[Math.floor(Math.random() * chars.length)];
    return `BN-${yy}${jjj}-${seq}`;
  };

  const STATUS_OPTIONS = [
    { value: "Available", label: "Available" },
    { value: "Reserved", label: "Reserved" },
    { value: "Quarantine", label: "Quarantine" },
    { value: "Expired", label: "Expired" },
    { value: "Consumed", label: "Consumed" },
  ];

  // Modal for adding Material/Unit
  const [show_modal, set_show_modal] = useState(false);
  const [add_number, set_add_number] = useState(0);
  const [get_status, set_get_status] = useState(false);
  const [lotQualityModal, setLotQualityModal] = useState({ open: false, bi: null, li: null });

  const getTestingTypeParams = (testingTypeId) => {
    const group = (parameterData || []).find(
      (g) => String(g.testing_type_id ?? g.id) === String(testingTypeId)
    );
    const items = group?.data || [];
    return items
      .map((it) => ({
        parameter_id: it.parameter_id,
        name: it.parameter_name,
        unit: it.unit || it.parameter_unit || "",
        data_type: it.data_type || "",
      }))
      .filter((p) => p.parameter_id);
  };

  const inferTestingTypeIdFromQualityParams = (qualityParams = []) => {
    if (!Array.isArray(qualityParams) || qualityParams.length === 0) return null;
    const selectedParamIds = new Set(
      qualityParams.map((qp) => Number(qp.parameter_id)).filter(Boolean)
    );
    if (!selectedParamIds.size) return null;
    for (const group of parameterData || []) {
      const groupParamIds = new Set(
        (group?.data || []).map((d) => Number(d.parameter_id)).filter(Boolean)
      );
      let isSubset = true;
      selectedParamIds.forEach((id) => {
        if (!groupParamIds.has(id)) isSubset = false;
      });
      if (isSubset) return group.testing_type_id ?? group.id;
    }
    return null;
  };

  // ==================== Formik ====================
  const validateInput = (input) => {
    const regex = /^(\d+(\.\d+)?)(,\s*\d+(\.\d+)?)*$/;
    return regex.test(input);
  };

  const emptyLot = () => ({
    lot_number: "",
    manufacturing_date: null,
    expiry_date: null,
    received_date: null,
    supplier_name: "",
    manufacturer_name: "",
    quantity_available: "",
    status: "Available",
    quality_parameters: [],
    quality_parameter_values: {},
  });
  const emptyBatch = () => ({ batch_number: "", lots: [emptyLot()] });

  const initialBatches = (() => {
    if (editRecord?.batches?.length) {
      return editRecord.batches.map((b) => ({
        batch_number: b.batch_number || "",
        lots: (b.lots?.length ? b.lots : [emptyLot()]).map((l) => ({
          lot_number: l.lot_number || "",
          manufacturing_date: l.manufacturing_date ? dayjs(l.manufacturing_date) : null,
          expiry_date: l.expiry_date ? dayjs(l.expiry_date) : null,
          received_date: l.received_date ? dayjs(l.received_date) : null,
          supplier_name: l.supplier_name || "",
          manufacturer_name: l.manufacturer_name || "",
          quantity_available: l.quantity_available ?? "",
          status: l.status || "Available",
          quality_parameters: Array.isArray(l.quality_parameters) && l.quality_parameters.length
            ? l.quality_parameters
            : (editRecord?.quality_parameters || []).map((p) => ({
                parameter_id: p.parameter_id,
                name: p.name,
                unit: p.unit || "",
                data_type: p.data_type || "",
              })),
          quality_parameter_values: l.quality_parameter_values || {},
        })),
      }));
    }
    return [emptyBatch()];
  })();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      material_name_id: editRecord?.material_name_id || "",
      material_type_id: editRecord?.material_type_id || type_id || "",
      unit_id: editRecord?.unit_id || "",
      packaging_size: editRecord?.packaging_size || "",
      specifications: editRecord?.specification || "",
      validity: editRecord?.validity || "",
      is_qr_scan: editRecord?.is_qr_scan || false,
      is_kitting: editRecord?.is_kitting || false,
      testing_type_id: editRecord?.testing_type_id || null,
      batches: initialBatches,
    },
    validationSchema: Yup.object({
      material_name_id: Yup.string().required("Material is required"),
      material_type_id: Yup.string().required("Material Type is required"),
      unit_id: Yup.string().required("Unit is required"),
      packaging_size: isKittingEnabled
        ? Yup.string()
            .required("Packaging Size is required")
            .test("valid-packaging", "Sizes must be numbers separated by commas", (value) => validateInput(value || ""))
        : Yup.string().nullable(),
      batches: Yup.array().of(
        Yup.object().test("batch-required-if-number", "", function (batch) {
          const { path, createError } = this;
          if (!batch?.batch_number) return true; // batch_number empty → skip all batch validation
          // batch_number filled → lots required
          if (!batch.lots || batch.lots.length === 0) {
            return createError({ path: `${path}.lots`, message: "At least one lot is required" });
          }
          for (let li = 0; li < batch.lots.length; li++) {
            const lot = batch.lots[li];
            const base = `${path}.lots[${li}]`;
            if (!lot.lot_number) return createError({ path: `${base}.lot_number`, message: "Lot number is required" });
            if (!lot.manufacturing_date) return createError({ path: `${base}.manufacturing_date`, message: "Manufacturing date is required" });
            if (!lot.expiry_date) return createError({ path: `${base}.expiry_date`, message: "Expiry date is required" });
            if (!lot.received_date) return createError({ path: `${base}.received_date`, message: "Received date is required" });
            if (!lot.supplier_name) return createError({ path: `${base}.supplier_name`, message: "Supplier is required" });
            if (!lot.manufacturer_name) return createError({ path: `${base}.manufacturer_name`, message: "Manufacturer name is required" });
            if (lot.quantity_available === "" || lot.quantity_available === null || lot.quantity_available === undefined)
              return createError({ path: `${base}.quantity_available`, message: "Quantity is required" });
          }
          return true;
        })
      ),
    }),
    onSubmit: (values) => {
      // eslint-disable-next-line no-console
      console.log('[AddIngredients submit]', values);
      const req = {
        ...values,
        packaging_size: isKittingEnabled ? (values.packaging_size || '').replace(/,\s*$/, "") : "",
        module_type: selectedModule,
        quality_parameters: getTestingTypeParams(values.testing_type_id).map((p) => ({
          parameter_id: p.parameter_id,
        })),
        batches: isKittingEnabled ? values.batches.map((b) => ({
          batch_number: b.batch_number,
          lots: b.lots.map((l) => ({
            ...l,
            manufacturing_date: l.manufacturing_date ? l.manufacturing_date.format("YYYY-MM-DD") : null,
            expiry_date: l.expiry_date ? l.expiry_date.format("YYYY-MM-DD") : null,
            received_date: l.received_date ? l.received_date.format("YYYY-MM-DD") : null,
          })),
        })) : [],
      };
      if (isEdit) {
        req.material_inventory_id = editRecord?.material_inventory_id;
      }
      add_Inventory(req);
    },
  });

  // ==================== API calls ====================
  const get_all_dropDown_Data = async () => {
    try {
      await bp_material_data({ module_type: selectedModule }, (res) =>
        setMaterialData(res?.data?.data || [])
      );
      await bp_material_type_data((res) =>
        setMaterialTypeData(res?.data?.data || [])
      );
      await bp_units_data((res) => setUnitData(res?.data?.data || []));
      // Quality Control Config drives BOTH the Quality Test dropdown (testing types)
      // AND the per-lot Quality Parameters dropdown (parameters per type)
      await bp_get_sampling_config_details((res) => {
        const groups = Array.isArray(res?.data?.data) ? res.data.data : [];
        setParameterData(groups);
        // Build a deduped list of testing types for the Quality Test dropdown
        const seen = new Set();
        const types = [];
        groups.forEach((g) => {
          const tid = g.testing_type_id ?? g.id;
          if (tid != null && !seen.has(tid)) {
            seen.add(tid);
            types.push({
              testing_type_id: tid,
              testing_type: g.testing_type_name || g.testing_type || g.name || `Type ${tid}`,
            });
          }
        });
        setTestingTypeData(types);
      });

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (!isEdit || !editRecord || !parameterData.length) return;
    if (formik.values.testing_type_id) return;
    const inferred = inferTestingTypeIdFromQualityParams(editRecord.quality_parameters || []);
    if (!inferred) return;
    formik.setFieldValue("testing_type_id", inferred);
    const defaults = getTestingTypeParams(inferred);
    const nextBatches = (formik.values.batches || []).map((b) => ({
      ...b,
      lots: (b.lots || []).map((l) => ({
        ...l,
        quality_parameters: (l.quality_parameters && l.quality_parameters.length) ? l.quality_parameters : defaults,
      })),
    }));
    formik.setFieldValue("batches", nextBatches);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, editRecord, parameterData]);

  const get_all_inventory = async () => {
    try {
      await bp_inventory_data({ module_type: selectedModule }, () => {});
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const add_Inventory = async (req) => {
    try {
      if (isEdit) {
        await update_material_inventory(req, success_add_inventory);
      } else {
        await bp_material_inentory_data(req, success_add_inventory);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const success_add_inventory = (res) => {
    if (res.status === "failed") {
      toast.warning(res.message);
    } else {
      toast.success(res.message);
      reset_function();
      get_all_inventory();
      set_get_submit_status(!get_submit_status);
      set_type_id(0);
      dispatch(set_submit_status());
      set_is_model_open(false);
      set_isEdit(false);
    }
  };

  const reset_function = () => {
    formik.setValues({
      material_name_id: "",
      material_type_id: type_id || "",
      unit_id: "",
      packaging_size: "",
      specifications: "",
      validity: "",
      is_qr_scan: false,
      is_kitting: false,
      batches: [emptyBatch()],
    });
    formik.setTouched({});
    formik.setErrors({});
  };

  // Helpers for batch/lot dynamic arrays
  const addBatch = () => formik.setFieldValue("batches", [...formik.values.batches, emptyBatch()]);
  const removeBatch = (bi) => {
    const next = formik.values.batches.filter((_, i) => i !== bi);
    formik.setFieldValue("batches", next.length ? next : [emptyBatch()]);
  };
  const addLot = (bi) => {
    const next = [...formik.values.batches];
    next[bi] = { ...next[bi], lots: [...next[bi].lots, emptyLot()] };
    formik.setFieldValue("batches", next);
  };
  const removeLot = (bi, li) => {
    const next = [...formik.values.batches];
    const lots = next[bi].lots.filter((_, i) => i !== li);
    next[bi] = { ...next[bi], lots: lots.length ? lots : [emptyLot()] };
    formik.setFieldValue("batches", next);
  };
  const setLotField = (bi, li, field, value) => {
    const next = [...formik.values.batches];
    next[bi] = {
      ...next[bi],
      lots: next[bi].lots.map((l, i) => (i === li ? { ...l, [field]: value } : l)),
    };
    formik.setFieldValue("batches", next);
  };
  const setBatchNumber = (bi, value) => {
    const next = [...formik.values.batches];
    next[bi] = { ...next[bi], batch_number: value };
    formik.setFieldValue("batches", next);
  };
  const openLotQualityModal = (bi, li) => setLotQualityModal({ open: true, bi, li });
  const closeLotQualityModal = () => setLotQualityModal({ open: false, bi: null, li: null });

  const setLotQualityParamValue = (bi, li, parameterId, value) => {
    const lot = formik.values.batches?.[bi]?.lots?.[li];
    if (!lot) return;
    const quality_parameter_values = {
      ...(lot.quality_parameter_values || {}),
      [parameterId]: value,
    };
    setLotField(bi, li, "quality_parameter_values", quality_parameter_values);
  };

  const getLotQualityFilledCount = (lot) => {
    const params = lot?.quality_parameters || [];
    const values = lot?.quality_parameter_values || {};
    const filled = params.filter((p) => {
      const value = values[p.parameter_id];
      return value !== undefined && value !== null && String(value).trim() !== "";
    }).length;
    return { filled, total: params.length };
  };

  // Helper: get lot field error (only shown when batch_number is filled)
  const getLotError = (bi, li, field) => {
    const batchNum = formik.values.batches[bi]?.batch_number;
    if (!batchNum) return null;
    const err = formik.errors?.batches?.[bi];
    if (!err) return null;
    // Yup path-based errors come as nested object after abortEarly:false, or as string from custom test
    if (typeof err === "string") return null;
    return err?.lots?.[li]?.[field] || null;
  };

  useEffect(() => {
    get_all_dropDown_Data();
    get_all_inventory();
  }, [selectedModule, get_status]);

  // ==================== Render ====================
  return (
    <>
      <Form
        layout="vertical"
        onFinish={formik.handleSubmit}
        style={{ width: "100%", maxHeight: "calc(100vh - 200px)", overflowY: "auto", paddingRight: 8 }}
      >
        <Row gutter={[16, 0]} align="bottom">
          {/* Material */}
          <Col xs={24} md={6}>
            <Form.Item
              label="Material"
              required
              extra=" "
              validateStatus={formik.touched.material_name_id && formik.errors.material_name_id ? "error" : ""}
              help={formik.touched.material_name_id && formik.errors.material_name_id}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Select
                  size="large"
                  showSearch
                  allowClear
                  style={{ flex: 1 }}
                  placeholder="Select Material"
                  value={formik.values.material_name_id || undefined}
                  onChange={(val) => formik.setFieldValue("material_name_id", val)}
                  onBlur={() => formik.setFieldTouched("material_name_id", true)}
                  disabled={isEdit}
                  filterOption={(input, option) =>
                    (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {materialData.map((m) => (
                    <Option key={m.material_id} value={m.material_id}>
                      {m.material_name}
                    </Option>
                  ))}
                </Select>
                {!isEdit && (
                  <Tooltip title="Add Material">
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={() => { set_show_modal(true); set_add_number(1); }}
                    />
                  </Tooltip>
                )}
              </Space.Compact>
            </Form.Item>
          </Col>

          {/* Material Type */}
          <Col xs={24} md={6}>
            <Form.Item
              label="Material Type"
              required
              extra=" "
              validateStatus={formik.touched.material_type_id && formik.errors.material_type_id ? "error" : ""}
              help={formik.touched.material_type_id && formik.errors.material_type_id}
            >
              <Select
                size="large"
                showSearch
                allowClear
                style={{ width: "100%" }}
                placeholder="Select Material Type"
                value={formik.values.material_type_id || undefined}
                onChange={(val) => formik.setFieldValue("material_type_id", val)}
                onBlur={() => formik.setFieldTouched("material_type_id", true)}
                disabled={isEdit}
              >
                {materialTypeData.map((m) => (
                  <Option key={m.material_type_id} value={m.material_type_id}>
                    {getMaterialTypeAlias(m.material_type)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* Packaging Size — only when Kitting Enable is on */}
          {isKittingEnabled && (
            <Col xs={24} md={6}>
              <Form.Item
                label="Packaging Size"
                required
                extra="Enter sizes like 2,3,4"
                validateStatus={formik.touched.packaging_size && formik.errors.packaging_size ? "error" : ""}
                help={formik.touched.packaging_size && formik.errors.packaging_size}
              >
                <Input
                  size="large"
                  placeholder="e.g. 2,3,4"
                  value={formik.values.packaging_size}
                  onChange={formik.handleChange("packaging_size")}
                  onBlur={formik.handleBlur("packaging_size")}
                />
              </Form.Item>
            </Col>
          )}

          {/* Unit */}
          <Col xs={24} md={6}>
            <Form.Item
              label="Unit"
              required
              extra=" "
              validateStatus={formik.touched.unit_id && formik.errors.unit_id ? "error" : ""}
              help={formik.touched.unit_id && formik.errors.unit_id}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Select
                  size="large"
                  showSearch
                  allowClear
                  style={{ flex: 1 }}
                  placeholder="Select Unit"
                  optionFilterProp="children"
                  value={formik?.values?.unit_id || undefined}
                  onChange={(val) => formik.setFieldValue("unit_id", val)}
                  onBlur={() => formik.setFieldTouched("unit_id", true)}
                  filterOption={(input, option) =>
                    (option?.children ?? "").toString().toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {unitData?.map((m) => (
                    <Select.Option key={m.id} value={m.id}>
                      {m.unit_name}
                    </Select.Option>
                  ))}
                </Select>
                <Tooltip title="Add Unit">
                  <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    size="large"
                    onClick={() => { set_show_modal(true); set_add_number(2); }}
                  />
                </Tooltip>
              </Space.Compact>
            </Form.Item>
          </Col>

          {/* Quality Test */}
          <Col xs={24} md={6}>
            <Form.Item label="Quality Test" extra=" ">
              <Select
                size="large"
                showSearch
                allowClear
                style={{ width: "100%" }}
                placeholder="Select Quality Test"
                optionFilterProp="label"
                value={formik?.values?.testing_type_id || undefined}
                onChange={(val) => {
                  formik.setFieldValue("testing_type_id", val || null);
                  const defaults = getTestingTypeParams(val);
                  // Apply selected test parameters to all lots by default
                  const next = (formik.values.batches || []).map((b) => ({
                    ...b,
                    lots: (b.lots || []).map((l) => ({
                      ...l,
                      quality_parameters: defaults,
                      quality_parameter_values: l.quality_parameter_values || {},
                    })),
                  }));
                  formik.setFieldValue("batches", next);
                }}
                options={(testingTypeData || []).map((t) => ({
                  value: t.testing_type_id ?? t.id,
                  label: t.testing_type ?? t.name ?? `#${t.testing_type_id ?? t.id}`,
                }))}
              />
            </Form.Item>
          </Col>

          {/* Validity — only in edit mode AND kitting enabled */}
          {isEdit && isKittingEnabled && (
            <Col xs={24} md={6}>
              <Form.Item label="Validity (Days)">
                <Input
                  size="large"
                  type="number"
                  placeholder="Enter validity"
                  value={formik.values.validity}
                  onChange={formik.handleChange("validity")}
                />
              </Form.Item>
            </Col>
          )}

          {/* ===== Batches → Lots — only when Kitting Enable is on ===== */}
          {isKittingEnabled && <Col xs={24}>
            <div style={{ borderTop: "1px dashed #d9d9d9", margin: "8px 0 16px" }} />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <strong style={{ fontSize: 14 }}>Batches & Lots</strong>
              <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={addBatch}>
                Add Batch
              </Button>
            </div>

            <div
              style={{
                maxHeight: 420,
                overflowY: "auto",
                paddingRight: 6,
                border: "1px solid #f0f0f0",
                borderRadius: 6,
                padding: 8,
              }}
            >
            {formik.values.batches.map((batch, bi) => (
              <div
                key={bi}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 6,
                  padding: 12,
                  marginBottom: 12,
                  background: "#fafbff",
                }}
              >
                <Row gutter={[12, 0]} align="middle">
                  <Col xs={24} md={8}>
                    <Form.Item label={`Batch Number #${bi + 1}`} style={{ marginBottom: 8 }}>
                      <Space.Compact style={{ width: "100%" }}>
                        <Input
                          size="large"
                          placeholder="Enter batch number"
                          value={batch.batch_number}
                          onChange={(e) => setBatchNumber(bi, e.target.value)}
                        />
                        <Tooltip title="Auto-generate (BN-YYJJJ-NNNN)">
                          <Button
                            size="large"
                            type="dashed"
                            onClick={() => setBatchNumber(bi, generateBatchNumber())}
                          >
                            Auto
                          </Button>
                        </Tooltip>
                      </Space.Compact>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={16} style={{ textAlign: "right" }}>
                    <Space>
                      <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => addLot(bi)}>
                        Add Lot
                      </Button>
                      <Button danger size="small" onClick={() => removeBatch(bi)}>
                        Remove Batch
                      </Button>
                    </Space>
                  </Col>
                </Row>

                <div
                  style={{
                    maxHeight: 280,
                    overflowY: "auto",
                    marginTop: 8,
                    paddingRight: 6,
                  }}
                >
                {batch.lots.map((lot, li) => (
                  <div
                    key={li}
                    style={{
                      border: "1px solid #eef0f5",
                      borderRadius: 4,
                      padding: 10,
                      marginTop: 10,
                      background: "#fff",
                    }}
                  >
                    <Row gutter={[12, 0]} align="middle">
                      <Col xs={24} md={20}>
                        <strong style={{ fontSize: 12, color: "#6b7280" }}>Lot #{li + 1}</strong>
                      </Col>
                      <Col xs={24} md={4} style={{ textAlign: "right" }}>
                        <Button danger size="small" onClick={() => removeLot(bi, li)}>
                          Remove
                        </Button>
                      </Col>
                    </Row>
                    <Row gutter={[12, 0]} style={{ marginTop: 8 }}>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Lot Number"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "lot_number") ? "error" : ""}
                          help={getLotError(bi, li, "lot_number")}
                        >
                          <Input
                            size="middle"
                            placeholder="Lot number"
                            value={lot.lot_number}
                            onChange={(e) => setLotField(bi, li, "lot_number", e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Manufacturing Date"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "manufacturing_date") ? "error" : ""}
                          help={getLotError(bi, li, "manufacturing_date")}
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            value={lot.manufacturing_date}
                            onChange={(d) => setLotField(bi, li, "manufacturing_date", d)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Expiry Date"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "expiry_date") ? "error" : ""}
                          help={getLotError(bi, li, "expiry_date")}
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            value={lot.expiry_date}
                            onChange={(d) => setLotField(bi, li, "expiry_date", d)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Received Date"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "received_date") ? "error" : ""}
                          help={getLotError(bi, li, "received_date")}
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            value={lot.received_date}
                            onChange={(d) => setLotField(bi, li, "received_date", d)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Supplier / Vendor"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "supplier_name") ? "error" : ""}
                          help={getLotError(bi, li, "supplier_name")}
                        >
                          <Input
                            placeholder="Enter supplier / vendor name"
                            value={lot.supplier_name}
                            onChange={(e) => setLotField(bi, li, "supplier_name", e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Manufacturer Name"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "manufacturer_name") ? "error" : ""}
                          help={getLotError(bi, li, "manufacturer_name")}
                        >
                          <Input
                            placeholder="Manufacturer"
                            value={lot.manufacturer_name}
                            onChange={(e) => setLotField(bi, li, "manufacturer_name", e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item
                          label="Quantity Available"
                          style={{ marginBottom: 8 }}
                          validateStatus={getLotError(bi, li, "quantity_available") ? "error" : ""}
                          help={getLotError(bi, li, "quantity_available")}
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            placeholder="Quantity"
                            value={lot.quantity_available}
                            onChange={(val) => setLotField(bi, li, "quantity_available", val)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={6}>
                        <Form.Item label="Status" style={{ marginBottom: 8 }}>
                          <Select
                            style={{ width: "100%" }}
                            value={lot.status}
                            onChange={(val) => setLotField(bi, li, "status", val)}
                            options={STATUS_OPTIONS}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={24}>
                        <Form.Item
                          label="Lot Quality"
                          style={{ marginBottom: 8 }}
                          extra={
                            formik.values.testing_type_id
                              ? "Click Quality to enter values for this lot"
                              : "Select a Quality Test first"
                          }
                        >
                          {(() => {
                            const selectedTtId = formik.values.testing_type_id;
                            const autoParams = getTestingTypeParams(selectedTtId);
                            if (!selectedTtId) {
                              return (
                                <Input
                                  disabled
                                  value="Select Quality Test first"
                                />
                              );
                            }
                            if (!autoParams.length) {
                              return (
                                <Input
                                  disabled
                                  value="No parameters configured for selected Quality Test"
                                />
                              );
                            }
                            return (
                              <div style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "flex-start" }}>
                                <Button
                                  type="primary"
                                  disabled={!autoParams.length}
                                  onClick={() => openLotQualityModal(bi, li)}
                                >
                                  Quality
                                </Button>
                                {(() => {
                                  const { filled, total } = getLotQualityFilledCount(lot);
                                  return (
                                    <span
                                      style={{
                                        fontSize: 12,
                                        color: "#334155",
                                        background: "#f1f5f9",
                                        border: "1px solid #cbd5e1",
                                        borderRadius: 6,
                                        padding: "4px 10px",
                                      }}
                                    >
                                      {filled}/{total} Filled
                                    </span>
                                  );
                                })()}
                              </div>
                            );
                          })()}
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                ))}
                </div>
              </div>
            ))}
            </div>
          </Col>}

          {/* Action Buttons */}
          <Col xs={24} md={24} style={{ textAlign: "right", paddingBottom: 24 }}>
            <Button size="large" type="default" onClick={reset_function} style={{ marginRight: 8 }}>
              Reset
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              onClick={() => {
                // Touch all fields so errors render in their inputs
                formik.setTouched(
                  Object.keys(formik.values).reduce(
                    (acc, k) => ({ ...acc, [k]: true }),
                    {}
                  ),
                  true
                );
              }}
            >
              {isEdit ? "Update" : "Submit"}
            </Button>
          </Col>
        </Row>
      </Form>

      <Modal
        title={(() => {
          const lot = formik.values.batches?.[lotQualityModal.bi]?.lots?.[lotQualityModal.li];
          return `Lot Quality Values${lot?.lot_number ? ` — ${lot.lot_number}` : ""}`;
        })()}
        open={lotQualityModal.open}
        onCancel={closeLotQualityModal}
        onOk={closeLotQualityModal}
        okText="Done"
        width={760}
      >
        {(() => {
          const lot = formik.values.batches?.[lotQualityModal.bi]?.lots?.[lotQualityModal.li];
          const params = lot?.quality_parameters || [];
          const values = lot?.quality_parameter_values || {};
          if (!params.length) return <div>No quality parameters configured.</div>;
          return (
            <Table
              dataSource={params}
              rowKey={(row) => row.parameter_id}
              pagination={false}
              size="small"
              bordered
              columns={[
                {
                  title: "Parameter",
                  dataIndex: "name",
                  key: "name",
                  width: "40%",
                  render: (name) => <span style={{ fontWeight: 600 }}>{name}</span>,
                },
                {
                  title: "Unit",
                  dataIndex: "unit",
                  key: "unit",
                  width: "15%",
                  render: (unit) => unit || "-",
                },
                {
                  title: "Value",
                  key: "value",
                  width: "45%",
                  render: (_, row) => (
                    <Input
                      value={values[row.parameter_id] ?? ""}
                      placeholder="Enter value"
                      onChange={(e) =>
                        setLotQualityParamValue(
                          lotQualityModal.bi,
                          lotQualityModal.li,
                          row.parameter_id,
                          e.target.value
                        )
                      }
                    />
                  ),
                },
              ]}
            />
          );
        })()}
      </Modal>

      <ConfigModal
        show_modal={show_modal}
        set_show_modal={set_show_modal}
        add_number={add_number}
        set_add_number={set_add_number}
        get_status={get_status}
        set_get_status={set_get_status}
      />
    </>
  );
};

export default AddIngredient;
